import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Layout, Form, Input, Row, Col, Card } from "antd";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Link from "next/link";
import { filter } from "lodash";
import RemoveDomain from "./RemoveDomain";
import AllowedForRole from "../Users/AllowedForRole";
import DisallowedForRole from "../Users/DisallowedForRole";
import ActivitySettingsModal from "./ActivitySettingsModal";
import Favicon from "./Favicon";
import { DomainTwoTone } from "@material-ui/icons";

const ActivityContainer = () => {
  const dispatch = useDispatch();
  const storeDomains = useSelector((state) => state.domains.domains);
  const [domains, setDomains] = useState([]);
  const { Content } = Layout;

  useEffect(() => {
    setDomains(storeDomains);
  }, [storeDomains]);

  const filterDomains = (e) => {
    const domainNames = filter(storeDomains, (domain) => {
      return domain.name.toLowerCase().includes(e.target.value.toLowerCase());
    });
    setDomains(domainNames);
  };

  const iconStyle = { fontSize: "26px", color: "#002f53" };

  return (
    <>
      <Layout style={{ background: "transparent" }}>
        <Card title="Domains">
          <Row>
            <Col offset={16} span={8} style={{ textAlign: "right" }}>
              <Input
                placeholder="Search Domain Name"
                onChange={filterDomains}
              />
            </Col>
          </Row>
        </Card>
        <br />
        <Content
          className="ant-table-content"
          style={{ backgroundColor: "#fff" }}
        >
          <Row>
            <Col
              span={24}
              style={{
                minHeight: "88vh",
                maxHeight: "88vh",
                overflowY: "auto",
              }}
            >
              <Table className="ant-table-thead">
                <Thead className="ant-table-thead">
                  <Tr>
                    <Th className="ant-table-cell">Domain Name</Th>
                    <Th></Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                {domains.length !== 0 ? (
                  <Tbody className="ant-table-tbody">
                    {domains.map((domain) => {
                      return (
                        <Tr key={domain.name}>
                          <Td>
                            <span className="mr-2">
                              <Favicon domain={domain} />
                            </span>
                            {domain.name}
                          </Td>
                          <Td style={{ textAlign: "center" }}>
                            <AllowedForRole roles={["admin"]}>
                              <RemoveDomain domain={domain} archive={true} />
                            </AllowedForRole>
                            <DisallowedForRole roles={["viewer"]}>
                              <ActivitySettingsModal
                                domain={domain}
                                type="link"
                              />
                            </DisallowedForRole>
                          </Td>
                          <Td className="pr-5" style={{ textAlign: "right" }}>
                            <DisallowedForRole roles={["viewer"]}>
                              <RemoveDomain domain={domain} />
                            </DisallowedForRole>
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                ) : (
                  <Tbody className="ant-table-tbody">
                    <Tr className="ant-table-row ant-table-row-level-0">
                      <Td
                        className="ant-table-cell"
                        colSpan="2"
                        style={{ textAlign: "center", fontWeight: "bold" }}
                      >
                        No Domain Found!
                      </Td>
                    </Tr>
                  </Tbody>
                )}
              </Table>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default ActivityContainer;
